module.exports = __webpack_public_path__ + "img/text-icon.8f3d095c.svg";